// Mirrored from mju-ai-workbench/shared/teams/orgTeamScope.ts at origin/main (07973e2a, D286) — keep the two identical but for this line.
/**
 * Where a team or specialist is kept on the workbench, in the organisation's words (D286): what the
 * workbench sends as `workbenchScope` on the organisation's record (shared/schemas/orgTeamsV2.ts), so
 * the console shows the same categories and another machine places a team it adds in the right one.
 *
 * Pure and dependency-free: the webview imports it without pulling the schemas in.
 */
/** The organisation's words for them: a repository's, a project's, or this computer's (every project on it). */
export const ORG_TEAM_WORKBENCH_SCOPES = ["repository", "project", "machine"];
export function orgScopeOf(scope) {
    return scope === "repo" ? "repository" : scope === "project" ? "project" : "machine";
}
export function workbenchScopeOf(scope) {
    return scope === "repository" ? "repo" : scope === "project" ? "project" : scope === "machine" ? "global" : undefined;
}
/**
 * Where an organisation record says it was kept: its `workbenchScope` when a workbench sent one (D286), else
 * what `origin.scope` implies — `organisation` was a machine-wide definition, `project` a repository's or a
 * project's (which of the two is not known: `project`, the wider one).
 */
export function recordScope(record) {
    const own = workbenchScopeOf(record.workbenchScope);
    if (own)
        return orgScopeOf(own);
    if (record.origin?.scope === "organisation")
        return "machine";
    if (record.origin?.scope === "project")
        return "project";
    return undefined;
}
//# sourceMappingURL=orgTeamScope.js.map